(function () {
    'use strict';

    angular.module('doclr.beschikbaarheden', ['doclr.resources.api', 'doclr.components.notification', 'doclr.components.colorselector', 'ui.router', 'doclr.disciplines'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('beschikbaarheden', {
                    url: '/beschikbaarheden/:typeId',

                    resolve: {
                        types: function (EditableBeschikbaarheidTypes, praktijkContext) {
                            return EditableBeschikbaarheidTypes.getList(praktijkContext.id).then(function (types) {
                                return _.sortBy(types, function (type) {
                                    return type.editeerbaar ? 0 : 1;
                                });
                            });
                        },
                        type: function ($stateParams, EditableBeschikbaarheidTypes, types, praktijkContext) {
                            var standaardAdresId = praktijkContext.adressen.filter(function (adres) {
                                return adres.standaard;
                            })[0].id;
                            if ($stateParams.typeId === 'nieuw' || types.length === 0) {
                                return {
                                    eventType: 'beschikbaarheid',
                                    zichtbaarVoorPatient: 'ja',
                                    editeerbaar: true,
                                    metAfspraakmogelijkheden: true,
                                    invulbaarDoorPatient: true,
                                    disciplineName: '',
                                    kleur: '#bee0f9',
                                    metEmail: false,
                                    praktijkAdresId: standaardAdresId,
                                    isActive: true
                                };
                            } else if ($stateParams.typeId) {
                                return EditableBeschikbaarheidTypes.load(decodeURIComponent(decodeURIComponent($stateParams.typeId)));
                            } else {
                                return EditableBeschikbaarheidTypes.load(types.filter(type => !!type.isActive).filter(type => type.eventType == 'beschikbaarheid')[0].id);
                            }
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.large.margin.html',
                            controller: function ($scope, $state, $window) {
                                $scope.goToDetail = function (typeId) {
                                    $state.go('beschikbaarheden', {typeId: typeId ? encodeURIComponent(encodeURIComponent(typeId)) : null}, {reload: true});
                                    $window.scroll({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                };
                            }
                        },
                        'sidebar@beschikbaarheden': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheden.sidebar.html',
                            controller: function ($scope, $state, types, type, borderColor, groupByKey, sortByProperty) {
                                $scope.showInactive = false;
                                $scope.types = types;

                                let activeTypes = types.filter(type => !!type.isActive)
                                    .filter(type => type.eventType == 'beschikbaarheid');
                                let inactiveTypes = types.filter(type => !type.isActive)
                                    .filter(type => type.eventType == 'beschikbaarheid');

                                $scope.groupedActiveTypes = groupAppointmentTypes(activeTypes);
                                $scope.groupedInActiveTypes = groupAppointmentTypes(inactiveTypes);

                                $scope.currentType = type;

                                $scope.isActiefType = function (type) {
                                    return $scope.currentType.id === type.id;
                                };

                                $scope.toggleInactiveTypes = () => $scope.showInactive = !$scope.showInactive;

                                $scope.borderColor = borderColor;

                                $scope.createNew = function () {
                                    $scope.goToDetail('nieuw');
                                };

                                function groupAppointmentTypes(appointmentTypes) {
                                    return groupByKey(appointmentTypes, (type) => type.disciplineName)
                                        .map(group => {
                                            return {
                                                disciplineName: group.key,
                                                types: group.values.sort(sortByProperty(x => doclrVertaal.translateType(x)))
                                            }
                                        })
                                        .sort(sortByProperty(x => x.disciplineName));
                                }
                            }
                        },
                        'content@beschikbaarheden': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidtypes.detail.html',
                            resolve: {
                                praktijk: function (Praktijk, praktijkContext) {
                                    return Praktijk.getInfo(praktijkContext.id);
                                },
                                mailOntvangers: function (EditableBeschikbaarheidTypes, praktijkContext, type) {
                                    return EditableBeschikbaarheidTypes.getMailOntvangers(type.id, praktijkContext.id);
                                }
                            },
                            controller: function ($state,
                                                  $scope,
                                                  EditableBeschikbaarheidTypes,
                                                  notificationService,
                                                  appContext,
                                                  praktijkContext,
                                                  praktijk,
                                                  type,
                                                  $uibModal,
                                                  mailOntvangers,
                                                  supportedLanguages,
                                                  DoclrModalService,
                                                  $sce) {
                                $scope.type = type;
                                $scope.appContext = appContext;
                                $scope.disciplineList = appContext.user.allowedDisciplineNames;
                                $scope.eventTypes = ['afspraakMogelijkheid', 'beschikbaarheid']
                                $scope.praktijk = praktijk;
                                $scope.praktijkContext = praktijkContext;
                                $scope.isNieuwType = function () {
                                    return !$scope.type.id;
                                };

                                $scope.makeDefault = function () {
                                    DoclrModalService.openConfirmModal(
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.title'),
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.question'))
                                        .then(() => EditableBeschikbaarheidTypes.setDefault(praktijkContext.id, type.id))
                                        .then(() => $scope.goToDetail(type.id));
                                }

                                $scope.mailTexts = [];

                                if (!$scope.isNieuwType()) {
                                    for (let language of supportedLanguages) {
                                        let value = getLanguage(language);
                                        $scope.mailTexts.push({
                                            language: language,
                                            value: value,
                                            toolTipValue: $sce.trustAsHtml(getTooltipValue(value))
                                        });
                                    }
                                }

                                function getLanguage(language) {
                                    if (type.mailText && type.mailText[language] && type.mailText[language].trim() !== '') {
                                        return type.mailText[language];
                                    }
                                    return undefined;
                                }

                                function getTooltipValue(value) {
                                    return value || doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.mailText.notset');
                                }

                                $scope.editMailText = function (mailText) {
                                    let mailTextClone = {
                                        language: mailText.language,
                                        value: mailText.value,
                                    }
                                    DoclrModalService.openEditModal(
                                        '/partials/beschikbaarheidtypes/beschikbaarheide.mailtext.edit.modal.html',
                                        {
                                            backdrop: 'static',
                                            modalSize: 'lg',
                                            model: mailTextClone,
                                        })
                                        .then(() => _onApplyEditMailText(mailTextClone), () => {
                                        });
                                }

                                function _onApplyEditMailText(mailText) {
                                    if (mailText.value) {
                                        mailText.value = mailText.value.trim();
                                    }
                                    EditableBeschikbaarheidTypes.saveMailText(type, mailText.language, mailText.value)
                                        .then(() => {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.mailtext.udated'));

                                            for (let i = 0; i < $scope.mailTexts.length; i++) {
                                                if ($scope.mailTexts[i].language === mailText.language) {
                                                    $scope.mailTexts[i].value = mailText.value;
                                                    $scope.mailTexts[i].toolTipValue = $sce.trustAsHtml(getTooltipValue(mailText.value));
                                                }
                                            }
                                        });

                                }


                                type.mailOntvangers = mailOntvangers;

                                $scope.bewaren = function () {
                                    if (!$scope.isNieuwType()) {
                                        EditableBeschikbaarheidTypes.saveWijzigingen(type).then(function () {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeUdated'));
                                            $scope.goToDetail(type.id);
                                        });
                                    } else {
                                        EditableBeschikbaarheidTypes.saveNieuwType(praktijkContext.id, type).then(function (nieuweType) {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeCreated'));
                                            $scope.goToDetail(nieuweType.id);
                                        });
                                    }
                                };

                                $scope.verwijderen = function () {
                                    $scope.confirmmodal = {
                                        title: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeTitle'),
                                        question: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeQuestion', {name: type.naam})
                                    };

                                    var modalInstance = $uibModal.open({
                                        templateUrl: '/partials/components/confirmmodal.html',
                                        scope: $scope
                                    });

                                    modalInstance.result.then(function () {
                                        EditableBeschikbaarheidTypes.verwijder(type).then(
                                            function () {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeDeleted'));
                                                $state.go('beschikbaarheden', {typeId: null});
                                            }
                                        );
                                    });
                                };

                                $scope.reload = function () {
                                    $scope.goToDetail($scope.type.id);
                                };

                            }
                        }
                    }

                });
        });
})();